// extracted by mini-css-extract-plugin
export default {"desktopDescription":"rAtrhp","mobileDescription":"nX9ylf","vertical":"iHoaeH"};